// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1tFgG","options":"AnswerScale_options__1F2rX","selected":"AnswerScale_selected__3_Ie6"};